<ng-container *ifNotCheckoutProcess>
    @if (content.promobar_turn_on) {
    <promo-bar [data]="content"
               (hiddenChange)="handleHiddenChange($event)"
               #cmsNodes></promo-bar>
    }
    <div class="page-header__wrapper"
         [dfHeaderUiHeader]
         [elementHeight]="'page-header-wrapper'"
         #cmsNodes>
        <header class="w-12 page-header"
                [class.sticky-native-height]="content.promobar_turn_on && !isPromobarHidden"
                [class.is-search-outlet-open]="searchTrayVisible"
                [toggleClass]="'is-meganav-open'"
                [toggleClassBy]="meganavToggleGroupId"
                [attr.id]="headerId"
                stickyNative
                stickyNativeBodyClass="page-header"
                [stickyNativeHeaderOnly]="true"
                [stickyNativeDetectDirection]="true"
                [elementHeight]="'page-header'">
            @if (content) {
            <!-- header -->
            <div class="page-header__inner"
                 [elementHeight]="'page-header-content'"
                 #cmsNode>
                <div class="wrap flex">
                    <div class="flex"
                         [style.gap.px]="8">
                        <!-- menu toggle -->
                        <button *ifSize="'MS'"
                                class="page-header__icon"
                                type="button"
                                aria-label="Menu"
                                (click)="openOffCanvas()">
                            <i class="icon-menu"
                               aria-hidden="true"></i>
                        </button>
                        <!-- logo -->
                        <div class="inline-block w-6-m w-3-s page-header__logo">
                            <a [ngClass]="{'pos-absolute-x pos-absolute-l z-2': searchTrayVisible}"
                               routerLink="/">
                                <img [image]="content.logo_image"
                                     [options]="{fitIn: true}"
                                     [attr.height]="client.isX || client.isL ? 23 : 28"
                                     [attr.width]="client.isX || client.isL ? 124 : 150"
                                     [attr.alt]="content.logo_alt"
                                     *ifNotTradeStore>
                                <img [image]="content.logoImageTrade"
                                     [options]="{fitIn: true}"
                                     [attr.height]="client.isX || client.isL ? 31.6 : 26"
                                     [attr.width]="client.isX || client.isL ? 120 : 99"
                                     [attr.alt]="content.logoAltTrade"
                                     *ifTradeStore>
                            </a>
                        </div>
                        <ng-container *ifSize="'XL'">
                            <!-- meganav -->
                            <meganav [items]="content.menu"></meganav>
                        </ng-container>
                    </div>
                    <div class="m-r--1 flex flex-middle flex-justify-end flex-grow"
                         [style.gap.px]="client.isX || client.isL ? 16 : 8">
                        <!-- *afterContentInit -->
                        <!-- search -->
                        @if (enabledAc) {
                        <advanced-commerce-search-form class="flex-grow-l flex-grow-x"
                                                       [style.maxWidth.px]="180"
                                                       searchId="header"
                                                       (closed)="closeSearchTray($event)"
                                                       (focusChange)="onSearchFocusChange($event)"></advanced-commerce-search-form>
                        } @else {
                        <search class="flex-grow-l flex-grow-x"
                                [style.maxWidth.px]="180"
                                searchId="header"
                                (focusChange)="onSearchFocusChange($event)"
                                (closed)="closeSearchTray($event)"></search>
                        }

                        <ng-container *ifSize="'XL'">
                            <multisite-switch-simple *ifNotTradeStore
                                                     style="display: block"
                                                     [headerSelector]="true"></multisite-switch-simple>
                        </ng-container>
                        <!-- wishlist -->
                        <wishlist-qty *ifNotTradeStore></wishlist-qty>
                        <account-information-centre-notification-bell
                                                                      *ifTradeStore></account-information-centre-notification-bell>
                        <ng-container *ifLoggedIn>
                            <!-- my account -->
                            <a class="link page-header__icon"
                               routerLink="/account"
                               routerLinkActive="is-active"
                               title="My Account">
                                <i class="icon-account"
                                   aria-hidden="true"></i>
                            </a>
                        </ng-container>
                        <ng-container *ifNotLoggedIn>
                            <!-- sign in -->
                            <a class="link page-header__icon"
                               routerLink="/login"
                               routerLinkActive="is-active"
                               appUserNotificationsQtyBullet
                               cy-loginBtn
                               title="Sign In">
                                <i class="icon-account"
                                   aria-hidden="true"></i>
                            </a>
                        </ng-container>
                        <!-- basket -->
                        <button *ifSize="'XL'"
                                [iCmsModalOpen]="ifBasketPage ? false : minibasketModalId"
                                type="button"
                                class="inline-flex">
                            <basket-qty class="inline-flex"></basket-qty>
                        </button>
                        <a *ifSize="'SM'"
                           routerLink='/basket'>
                            <basket-qty></basket-qty>
                        </a>
                    </div>
                </div>
            </div>
            <ng-container *afterContentInit>
                <!-- search outlet -->
                <div class="pos-absolute search-outlet-wrapper pe-none w-12">
                    <div class="hide-up-container">
                        <div class="ng-hide-animate hide-up hide-up-max pe-auto ng-hide"
                             [ngClass]="{'ng-hide': !searchTrayVisible}"
                             [offClickOff]="!searchTrayVisible"
                             [offClickFilter]="enabledAc ? 'advanced-commerce-search-form' : 'search'"
                             (offClick)="searchTrayVisible = false">

                            @if(enabledAc) {
                            @if(searchTrayVisible) {
                            <advanced-commerce-search-outlet class="w-12 search-outlet scrolling-touch overflow-y-auto bg-col-w"
                                                             searchId="header"></advanced-commerce-search-outlet>
                            }
                            } @else {
                            <search-outlet class="w-12 search-outlet scrolling-touch overflow-y-auto bg-col-w"
                                           searchId="header"
                                           #cmsNodes></search-outlet>
                            }
                        </div>
                    </div>
                </div>
                <!-- meganav content -->
                <meganav-content *ifSize="'XL'"
                                 [ngClass]="{'ng-hide': searchTrayVisible}"
                                 class="block"
                                 [items]="content.menu"
                                 #cmsNodes></meganav-content>
            </ng-container>
            }
        </header>
    </div>
</ng-container>
<!-- Checkout quarantine header-->
<div class="w-12 center page-header--checkout pos-relative bg-col-w"
     *ifCheckoutProcess>
    <div class="pos-absolute left-2 top-2 left-0-m left-0-s">
        <div class="flex flex-middle m-l-5 m-t-1">
            <i class="icon-lock fs-8"></i>
            <p class="p1 m-l"
               *ifSize="'XL'">{{'Secure Checkout' | translate}}</p>
        </div>
    </div>
    <!-- logo -->
    <a class="inline-block page-header__logo quarantine p-t-3-s p-t-3-m"
       routerLink="/">
        <img [image]="content.logo_image"
             [options]="{fitIn: true}"
             [attr.height]="client.isX || client.isL ? 23 : 28"
             [attr.width]="client.isX || client.isL ? 124 : 150"
             [attr.alt]="content.logo_alt">
    </a>
</div>
<!-- meganav overlay -->
<meganav-overlay *ifNotCheckoutProcess></meganav-overlay>